module.exports = __webpack_public_path__ + "img/PL08060.00c45cdb.png";